import React from 'react';
import styles from './styles.module.scss';

const Mobile = () => {
  return <div>Verify Registrations Mobile</div>;
};

export default Mobile;
